import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: ${theme.spacing.md};
  gap: ${theme.spacing.md};
`
